import { Pause, PlayArrow } from '@mui/icons-material'
import { Box, Button } from '@mui/material'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import PageLoader from 'components/PageLoader'
import { axiosPost } from 'connectors/axiosPost'
import { useAlert } from 'context/AlertContext'
import { useAuthContext } from 'context/AuthContext'
import { useTranslation } from 'react-i18next'
import { PrizeDrawRequestStatus } from 'types/prize-draw'

export type ToggleRequestStateProps = {
  requestId: number
  status: PrizeDrawRequestStatus
  type: 'prize-embargo' | 'prize-draw'
}

export const ToggleRequestState = ({ requestId, status, type }: ToggleRequestStateProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'prizesManagement.requestStatuses' })
  const { token, refreshToken } = useAuthContext()
  const { changeMessage } = useAlert()
  const queryClient = useQueryClient()

  const { mutate, isLoading } = useMutation(
    async (action: 'play' | 'pause') =>
      await axiosPost(token, refreshToken, `${type}/request/${action}/${requestId}`, {}),
    {
      onSuccess: (_, data) => {
        changeMessage(`Request changed to ${t(data === 'play' ? 'inprogress' : 'onhold')}`, 'info')
        queryClient.refetchQueries({ exact: false, queryKey: [`${type}-requests-query`] })
      },
      onError: data => {
        changeMessage(`Failure during changng request status`, 'warning')
        queryClient.refetchQueries({ exact: false, queryKey: [`${type}-requests-query`] })
      },
    }
  )

  return (
    <Box>
      {status === 'onhold' && (
        <Button color="info" startIcon={<PlayArrow fontSize="small" />} onClick={() => mutate('play')}>
          Turn on process
        </Button>
      )}
      {(status === 'inprogress' || status === 'new') && (
        <Button color="warning" startIcon={<Pause fontSize="small" />} onClick={() => mutate('pause')}>
          Hold process
        </Button>
      )}

      {isLoading && <PageLoader />}
    </Box>
  )
}
